import { all, fork } from '@redux-saga/core/effects';
import appSagas from './app';

export default function* rootSaga() {
  yield all([fork(appSagas)]);
}
